import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RightOutlined } from '@ant-design/icons';

// COMPONENTS
import OrdersList from 'components/Orders/OrdersList/OrdersList';

// DS
import {
  Row,
  Col,
  VertContainer,
  VertPagination,
  VertTypography,
  VertBreadcrumb,
  VertIcon,
  VertSkeleton,
} from '@vertem-core/vertice-ds';

// SERVICES
import PipeProvider from '../../Services/Providers/PipeProvider';
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';

// STYLES
import 'Assets/styles/default/pages/orders/OrdersStyles.less';

// UTILS
import generateUUID from 'Utils/generateUUID';
import { giftsRedeemedByParticipant } from 'redux/Reducers/Gift/GiftApi';

// ORDERS PAGE
const OrdersGiftPage = () => {
  /* Hooks */
  const dispatch = useDispatch();
  const data = useSelector(({ OrdersList: data }) => data);
  const {
    giftInfo: giftsActiveOnCampaign,
    redeemedGifts,
    isLoadingProducts,
  } = useSelector(({ Gift: data }) => data);
  /* State */
  const [offsetItems, setOffsetItems] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [customAliasUUID, setCustomAliasUUID] = useState(generateUUID());
  const [customAliasUUIDVendors, setCustomAliasUUIDVendors] = useState(
    generateUUID()
  );

  /* Var */
  const qtdItemsDisplayed = 5;
  const isLoading = data.isLoading;
  const orderList = data.orders ? data.orders : [];
  const breadcrumbItems = [
    {
      title: 'Início',
      path: '/',
    },
    {
      title: 'Meus resgates',
      path: '/my-orders',
    },
  ];

  /* Handlers */
  const pageChangeHandler = async (current, pageSize) => {
    setOffsetItems((current - 1) * pageSize);
    setCurrentPage(current);
  };

  /* Utils */
  const loadOrdersList = (currentOffset = 0) => {
    setTotalItems(redeemedGifts.length);
  };

  /* Lifecycles */

  useEffect(() => {
    if (giftsActiveOnCampaign?._id) {
      dispatch(giftsRedeemedByParticipant(giftsActiveOnCampaign?._id));
    }
  }, [giftsActiveOnCampaign]);

  useEffect(() => {
    if (data?.requestCompleted) {
      setTotalItems(data.total);
    }
  }, [data?.requestCompleted, data?.total]);

  useEffect(() => {
    loadOrdersList(offsetItems);
  }, [offsetItems, currentPage]);

  /* Renders */
  if (isLoading || isLoadingProducts) {
    return (
      <VertContainer
        spacingX="regular"
        className="orders-page-wrapper padding-top-small padding-bottom-regular"
      >
        <VertSkeleton paragraph={{ rows: 30 }} active />
      </VertContainer>
    );
  }
  return (
    <PipeProvider
      apiSymbols={[
        {
          symbol: 'FETCH_ORDERS_LIST',
          alias: customAliasUUID,
          payload: { offset: offsetItems, limit: qtdItemsDisplayed },
        },
        { symbol: 'FETCH_VENDORS', alias: customAliasUUIDVendors },
      ]}
    >
      <VertContainer
        spacingX="regular"
        className="orders-page-wrapper padding-top-small padding-bottom-regular"
      >
        <VertBreadcrumb
          separator={<VertIcon component={RightOutlined} />}
          items={breadcrumbItems}
        />

        <Row className="orders-page-title" align="middle" gutter={6}>
          <VertTypography.Title>Meus resgates</VertTypography.Title>
        </Row>

        <OrdersList ordersListData={redeemedGifts} isGift />

        <Row className="orders-page-list" align="middle" gutter={6}>
          {(orderList.length && (
            <Col className="col">
              <Col className="orders-pagination">
                <VertPagination
                  current={offsetItems / qtdItemsDisplayed + 1}
                  pageSize={qtdItemsDisplayed}
                  total={totalItems}
                  onChange={pageChangeHandler}
                  template="marketplace"
                  defaultCurrent={1}
                  simple={false}
                  showSizeChanger={false}
                  showLessItems
                />
              </Col>
            </Col>
          )) ||
            ''}
        </Row>
      </VertContainer>
    </PipeProvider>
  );
};

export default OrdersGiftPage;
